<template>
  <a href="javascript:void(0)" @click="onLogin($event)" class="ta-link-to-login">
    <slot />
  </a>
</template>

<script>
import {openLogin, openLoginAndPreserveUrl} from "@/helpers";
export default {
  name: "LinkToLogin",
  props: {
    preserve: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onLogin(ev) {
      if (this.preserve) {
        openLoginAndPreserveUrl(ev)
      } else {
        openLogin(ev)
      }
    }
  }
}
</script>

<style scoped>

</style>
